/**
 * @Author : zhouqinze
 * @Date : 2019-12-29
 * @Version : 1.0
 * @Content : 员工活动
 **/
<template>
    <div>
        <div class="aboutComHead">
        <p>员工活动</p>
        <p><span></span><span></span></p>
        </div>
        <div class="actCon">
            <div class="actBox">
                <div class="boxLeft oneLeft">
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_01.png" alt=""></div>
                    <p>Motion</p>
                </div>
                <div class="boxRight oneRight">
                    <div>
                        <p>Badminton</p>
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_02.png" alt="">
                    </div>
                    <div>
                        <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_03.png" alt="">
                    </div>
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_04.png" alt=""></div>
                </div>
                <div class="boxText">
                    <div>
                        <h3>每周活动</h3>
                        <p>公司每周组织羽毛球活动，丰富员工生活</p>
                    </div>
                </div>
            </div>
            <div class="actBox">
                <div class="boxLeft">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_05.png" alt="">
                </div>
                <div class="boxRight twoRight">
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_06.png" alt=""></div>
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_07.png" alt=""></div>
                    <div>League building</div>
                </div>
                <div class="boxText">
                    <div>
                        <h3>不定期团建</h3>
                        <p>公司不定期组织团建，增强员工之间的默契</p>
                    </div>
                </div>
            </div>
            <div class="actBox">
                <div class="boxLeft threeLeft">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_08.png" alt="">
                    <div>Tourism</div>
                </div>
                <div class="boxRight">
                    <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yghd_09.png" alt="">
                </div>
                <div class="boxText">
                    <div>
                        <h3>年度旅游</h3>
                        <p>公司每年组织员工旅行，放松身心，开拓视野</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import img9 from '../assets/img/img_yghd_09.png'
export default {
    data() {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: 1.25rem;
        font-weight: bold;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .actCon{
        .actBox{
            height: 25.875rem;
            // padding-bottom: 33px;
            // display: flex;
            // display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
            // display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
            // display: -ms-flexbox;      /* TWEENER - IE 10 */
            // display: -webkit-flex;     /* NEW - Chrome */
            // -webkit-justify-content: center;
            // -moz-justify-content: center;
            // -ms-justify-content: center;
            // -o-justify-content: center;
            // justify-content: center;
            border-bottom: .0625rem solid #1A96D5;
            margin-bottom: 1.9375rem;
            .boxLeft,.boxRight{
                float: left;
                width: 18.75rem;
                color: rgba(168,207,251,1);
                box-sizing: border-box;
                height: 23.75rem;
            }
            .boxLeft{
                margin-right: .625rem;
            }
            .oneLeft{
                img{
                    display: block;
                    width: 18.75rem;
                    height: 19.25rem;
                }
                p{
                    height: 4.5rem;
                    line-height: 4.5rem;
                    font-size: 3.75rem;
                    background:#018CF4;
                }
            }
            .oneRight{
                // background: #444;
                div:first-child{
                    height: 6.75rem;
                    margin-bottom: .25rem;
                    display: flex;
                    p{
                        width: 12.125rem;
                        background: #0187EC;
                        font-size: 1.875rem;
                        margin-right: .1875rem;
                        padding-top: 3.4375rem;
                    }
                }
                div:nth-child(2){
                    height: 7.0625rem;
                    margin-bottom: .25rem;
                }
                div:last-child{
                    height: 9.4375rem;
                }
            }
            .twoRight{
                div{
                    img{
                        display: block;
                    }
                }
                div:first-child,div:nth-child(2){
                    height: 9.4375rem;
                    margin-bottom: .25rem;
                }
                div:last-child{
                    height: 4.5rem;
                    font-size: 1.875rem;
                    line-height: 4.5rem;
                    background:#018CF4;
                }
            }
            .threeLeft{
                img{
                    height: 19rem;
                    display: block;
                    margin-bottom: .25rem;
                }
                div{
                    height: 4.5rem;
                    font-size: 1.875rem;
                    line-height: 4.5rem;
                    background:#018CF4;
                }
            }
            .boxText{
                float: right;
                height: 23.75rem;
                text-align: left;
                width: 13.75rem;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                h3{
                    color: #0187EC;
                    font-size: 2.25rem;
                    line-height: 2.25rem;
                    margin-bottom: 1.125rem;
                    width: 100%;
                }
                p{
                    font-size: 20px;
                    color: #444;
                }
            }
        }
    }
    // .actCon{
    //     .actBox{
    //         height: 414px;
    //         // padding-bottom: 33px;
    //         display: flex;
    //         border-bottom: 1px solid #1A96D5;
    //         margin-bottom: 31px;
    //         .boxLeft,.boxRight{
    //             width: 300px;
    //             color: rgba(168,207,251,1);
    //             box-sizing: border-box;
    //             height: 380px;
    //         }
    //         .boxLeft{
    //             margin-right: 10px;
    //         }
    //         .oneLeft{
    //             img{
    //                 display: block;
    //                 width: 300px;
    //                 height: 308px;
    //             }
    //             p{
    //                 height: 72px;
    //                 line-height: 72px;
    //                 font-size: 60px;
    //                 background:#018CF4;
    //             }
    //         }
    //         .oneRight{
    //             // background: #444;
    //             div:first-child{
    //                 height: 108px;
    //                 margin-bottom: 4px;
    //                 display: flex;
    //                 p{
    //                     width: 194px;
    //                     background: #0187EC;
    //                     font-size: 30px;
    //                     margin-right: 3px;
    //                     padding-top: 55px;
    //                 }
    //             }
    //             div:nth-child(2){
    //                 height: 113px;
    //                 margin-bottom: 4px;
    //             }
    //             div:last-child{
    //                 height: 151px;
    //             }
    //         }
    //         .twoRight{
    //             div{
    //                 img{
    //                     display: block;
    //                 }
    //             }
    //             div:first-child,div:nth-child(2){
    //                 height: 151px;
    //                 margin-bottom: 4px;
    //             }
    //             div:last-child{
    //                 height: 72px;
    //                 font-size: 30px;
    //                 line-height: 72px;
    //                 background:#018CF4;
    //             }
    //         }
    //         .threeLeft{
    //             img{
    //                 height: 304px;display: block;
    //                 margin-bottom: 4px;
    //             }
    //             div{
    //                 height: 72px;
    //                 font-size: 30px;
    //                 line-height: 72px;
    //                 background:#018CF4;
    //             }
    //         }
    //         .boxText{
    //             height: 380px;
    //             margin-left: 41px;
    //             text-align: left;
    //             display: flex;
    //             flex-direction: column;
    //             justify-content: space-between;
    //             div{
    //                 h3{
    //                     color: #0187EC;
    //                     font-size: 36px;
    //                     line-height: 36px;
    //                     margin-bottom: 18px;
    //                 }
    //                 p{
    //                     font-size: 20px;
    //                     color: #444;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>